import { render, staticRenderFns } from "./ListCategory.vue?vue&type=template&id=3989cac6&scoped=true&"
import script from "./ListCategory.vue?vue&type=script&lang=js&"
export * from "./ListCategory.vue?vue&type=script&lang=js&"
import style0 from "./ListCategory.vue?vue&type=style&index=0&id=3989cac6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3989cac6",
  null
  
)

export default component.exports